// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setCustomPDFReportToDuplicate = createAction('[Custom PDF Report to Duplicate] Set Custom PDF Report to Duplicate', props());
export const clearCustomPDFReportToDuplicate = createAction('[Custom PDF Report to Duplicate] Clear Custom PDF Report to Duplicate');
